import angular from 'angular';
import adpHeaderLogoTitle from './adpHeaderLogoTitle/adpHeaderLogoTitle';
import adpSidePanel from './adpSidePanel/adpSidePanel';
import adpSubnavigation from './adpSubnavigation/adpSubnavigation';
import adpComponentCategory from './adpComponentCategory/adpComponentCategory';
import adpComponentSection from './adpComponentSection/adpComponentSection';
import adpComponentsList from './adpComponentsList/adpComponentsList';
import adpToggler from './adpToggler/adpToggler';
import adpNotificationsList from './adpNotificationsList/adpNotificationsList';
import adpListItem from './adpListItem/adpListItem';
import adpTabs from './adpTabs/adpTabs';
import adpMainHeader from './adpMainHeader/adpMainHeader';
import adpDefinitionList from './adpDefinitionList/adpDefinitionList';
import adpPanelWithHeading from './adpPanelWithHeading/adpPanelWithHeading';
import adpLink from './adpLink/adpLink';
import adpDropdown from './adpDropdown/adpDropdown';
import adpHeaderTopBar from './adpHeaderTopBar/adpHeaderTopBar';
import adpInput from './adpInput/adpInput';
import adpButton from './adpButton/adpButton';
import adpIconButton from './adpIconButton/adpIconButton';
import adpMenuToggler from './adpMenuToggler/adpMenuToggler';
import adpMainBreadcrumb from './adpMainBreadcrumb/adpMainBreadcrumb';
import adpTextLink from './adpTextLink/adpTextLink';
import adpSelectDropdown from './adpSelectDropdown/adpSelectDropdown';
import adpSelect from './adpSelect/adpSelect';
import adpNotificationIcon from './adpNotificationIcon/adpNotificationIcon';
import adpVerticalNavigation from './adpVerticalNavigation/adpVerticalNavigation';
import adpMainNavigation from './adpMainNavigation/adpMainNavigation';
import adpTint from './adpTint/adpTint';
import adpChartLegendItem from './adpChartLegendItem/adpChartLegendItem';
import adpChartLegend from './adpChartLegend/adpChartLegend';
import adpTooltip from './adpTooltip/adpTooltip';
import adpHoverTooltip from './adpHoverTooltip/adpHoverTooltip';
import adpToast from './adpToast/adpToast';
import adpSearchInput from './adpSearchInput/adpSearchInput';
import adpPlainTable from './adpPlainTable/adpPlainTable';
import adpPeriodIndicator from './adpPeriodIndicator/adpPeriodIndicator';
import adpTimelineContextualMenu from './adpTimelineContextualMenu/adpTimelineContextualMenu';
import adpCheckbox from './adpCheckbox/adpCheckbox';
import adpDonutChart from './adpDonutChart/adpDonutChart';
import adpDropdownTabs from './adpDropdownTabs/adpDropdownTabs';
import adpAllErrorsList from './adpAllErrorsList/adpAllErrorsList';
import adpStatusIcon from './adpStatusIcon/adpStatusIcon';
import adpPinIcon from './adpPinIcon/adpPinIcon';
import adpCircleIcon from './adpCircleIcon/adpCircleIcon';
import adpFileUpload from './adpFileUpload/adpFileUpload';
import adpSideModal from './adpSideModal/adpSideModal';
import adpSimpleTable from './adpSimpleTable/adpSimpleTable';
import adpTypeahead from './adpTypeahead/adpTypeahead';
import adpModal from './adpModal/adpModal';

let componentModule = angular.module('adp.components', [
  adpHeaderLogoTitle,
  adpSidePanel,
  adpSubnavigation,
  adpComponentCategory,
  adpComponentSection,
  adpComponentsList,
  adpToggler,
  adpNotificationsList,
  adpListItem,
  adpTabs,
  adpMainHeader,
  adpDefinitionList,
  adpPanelWithHeading,
  adpLink,
  adpDropdown,
  adpHeaderTopBar,
  adpInput,
  adpButton,
  adpIconButton,
  adpMenuToggler,
  adpMainBreadcrumb,
  adpTextLink,
  adpSelect,
  adpSelectDropdown,
  adpNotificationIcon,
  adpVerticalNavigation,
  adpMainNavigation,
  adpTint,
  adpChartLegendItem,
  adpChartLegend,
  adpTooltip,
  adpHoverTooltip,
  adpToast,
  adpSearchInput,
  adpPlainTable,
  adpPeriodIndicator,
  adpTimelineContextualMenu,
  adpCheckbox,
  adpDonutChart,
  adpDropdownTabs,
  adpAllErrorsList,
  adpStatusIcon,
  adpPinIcon,
  adpCircleIcon,
  adpFileUpload,
  adpSideModal,
  adpSimpleTable,
  adpTypeahead,
  adpModal,

])

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./src/app/components/components.js